import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '../ui/button';

export default function RegionUploadSuccess({ goToNextPage }) {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  const onContinue = () => {
    navigate('/region/support');
  };

  const onSaveAndExit = () => {
    localStorage.removeItem('regionToken');
    localStorage.removeItem('lang');
    localStorage.removeItem('theme');
    navigate('/region/login');
  };

  const onNextUpload = () => {
    navigate('/region/video-region');
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
      style={{ display: open ? 'flex' : 'none' }}>
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 p-8">
        <div className="text-center">
          <img src="/images/icons/thumbs-up.png" className="w-20 mx-auto mb-6" />
        </div>
        <h2 className="text-2xl font-bold text-center mb-8 quickSand">
          Votre vidéo a été téléchargée.
        </h2>
        <div className="flex flex-col gap-4">
          <Button.ButtonOutlined
            className={'bg-cblue-500 text-white rounded-xl px-4 py-2 border-2 border-cblue-500'}
            handler={onNextUpload}>
            ENREGISTRER UNE AUTRE VIDÉO !
          </Button.ButtonOutlined>
          <Button.ButtonOutlined
            className={'bg-white text-cblue-500 rounded-xl px-4 py-2 border-2 border-cblue-500'}
            handler={onSaveAndExit}>
            DÉCONNECTER !
          </Button.ButtonOutlined>
        </div>
      </div>
    </div>
  );
}
